import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-white/5 mt-24 md:mt-32" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-16">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="font-display text-2xl font-bold tracking-tight">
              S<span className="text-gold">Ō</span>HM
            </Link>
            <p className="text-sm text-muted-foreground mt-3 leading-relaxed max-w-xs">
              Premium gold & silver jewelry. Crafted with care, priced with transparency.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-4">Shop</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/gold" className="text-foreground/70 hover:text-foreground transition-colors">Gold Collection</Link></li>
              <li><Link to="/silver" className="text-foreground/70 hover:text-foreground transition-colors">Silver Collection</Link></li>
              <li><Link to="/custom" className="text-foreground/70 hover:text-foreground transition-colors">Custom Jewelry</Link></li>
              <li><Link to="/rates" className="text-foreground/70 hover:text-foreground transition-colors">Live Rate</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-4">Company</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="text-foreground/70 hover:text-foreground transition-colors">About</Link></li>
              <li><Link to="/purity-standards" className="text-foreground/70 hover:text-foreground transition-colors">Purity Standards</Link></li>
              <li><Link to="/learn" className="text-foreground/70 hover:text-foreground transition-colors">Journal</Link></li>
              <li><Link to="/faq" className="text-foreground/70 hover:text-foreground transition-colors">FAQ</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-4">Support</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/contact" className="text-foreground/70 hover:text-foreground transition-colors">Contact</Link></li>
              <li><Link to="/returns" className="text-foreground/70 hover:text-foreground transition-colors" data-testid="footer-returns-link">Returns & Cancellations</Link></li>
              <li><Link to="/verify" className="text-foreground/70 hover:text-foreground transition-colors">Verify Certificate</Link></li>
              <li><a href="mailto:hello@sohm.com" className="text-foreground/70 hover:text-foreground transition-colors" data-testid="footer-email-link">hello@sohm.com</a></li>
              <li><a href="tel:+918983636311" className="text-foreground/70 hover:text-foreground transition-colors" data-testid="footer-phone-link">+91 89836 36311</a></li>
              <li><a href="https://wa.me/918983636311" className="text-foreground/70 hover:text-foreground transition-colors" data-testid="footer-whatsapp-link">WhatsApp</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">&copy; {new Date().getFullYear()} SŌHM. All rights reserved.</p>
          <div className="flex items-center gap-6 text-xs text-muted-foreground">
            <span>Product-specific purity details</span>
            <span className="w-1 h-1 rounded-full bg-border" />
            <span>Transparent Pricing</span>
            <span className="w-1 h-1 rounded-full bg-border" />
            <span>Razorpay Secured</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
